import { render, staticRenderFns } from "./PaymentOrderBigMealCard.vue?vue&type=template&id=1dceac80&scoped=true"
import script from "./PaymentOrderBigMealCard.vue?vue&type=script&lang=js"
export * from "./PaymentOrderBigMealCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentOrderBigMealCard.vue?vue&type=style&index=0&id=1dceac80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dceac80",
  null
  
)

export default component.exports